import { Paper, Button, styled } from '@mui/material';

export const RefreshDataWrapper = styled(Paper)(({ theme }) => ({
	position: 'fixed',
	zIndex: 9999,
	width: '400px',
	padding: '8px',
	display: 'flex',
	gap: '16px',
	bottom: 0,
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: theme.palette.warning.light,
	border: `2px solid ${theme.palette.warning.contrastText}`,
	boxShadow: '0px 8px 32px 0px rgba(130, 125, 131, 0.5)',
	justifyContent: 'center',
	alignItems: 'center',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
	color: theme.palette.error.contrastText,
	background: 'transparent',
}));
